<template>
  <div class="view box grow" :class="classList">
    <div class="flex column">
      <div v-for="item in computedThreatSummary" :key="item.name" class="item">
        <div class="summary-row" v-if="trailIDetails[item.name]">
          <div v-if="!liteTableView" class="summary-label">{{ item.value }}</div>
          <div class="summary-value">
            <trail-ioc-list
              v-if="item.name === 'collapsedTrailIocList'"
              :iocList="item.summaryValue"
              :classList="classList"
              :placement="placement"
              :itemsShown="liteTableView ? 1 : 2"/>
            <div v-if="item.name !== 'collapsedTrailIocList'">{{ item.summaryValue }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {format} from 'date-fns';
import TrailIocList from "./TrailIocList.vue";

export default {
  name: "ThreatSummary",
  props: {
    trailIDetails: {
      type: Object,
      default: function () {
        return {}
      }
    },
    liteTableView: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    placement: {
      type: String,
      default: () => "right"
    },
    classList: {type: String}
  },
  data() {
    return {
      threatSummary: [
        {
          name: 'startTime',
          value: 'Progression Reported'
        },
        {
          name: 'dwellTime',
          value: 'Dwell Time'
        },
        {
          name: 'collapsedTrailIocList',
          value: 'MITRE Technique'
        }
      ]
    };
  },
  computed: {
    computedThreatSummary: function () {
      return this.threatSummary.filter(item => this.liteTableView ? item.name === 'collapsedTrailIocList' : true).map(item => ({
        ...item,
        summaryValue: this.getSummaryValue(item.name)
      }));
    }
  },
  methods: {
    getSummaryValue: function (name) {
      const value = this.trailIDetails[name];
      if (!value) {
        return '';
      }
      if (name === 'riskLevel') {
        return value.label;
      } else if (name === 'startTime') {
        return format(new Date(value), 'MMM dd yyyy');
      } else {
        return value;
      }
    }
  },
  components: {TrailIocList}
};
</script>
<style scoped>
@import "assets/styles/_variables.css";

.view {
  margin-bottom: 15px;
}

.page-toolbar-filter {
  margin-top: -10px;
  height: 48px;
  border-bottom: 2px solid #e4e7ed;
}

.summary-row {
  display: flex;
  width: 100%;
  font-size: 14px;
  margin-bottom: 15px;

  .summary-label {
    width: 50%;
  }

  .summary-value {
    font-weight: bold;
  }
}

.trail-ioc-list {
  flex-direction: row;
  padding: 0 !important;
  margin-bottom: 0;

  .summary-row {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/monitor/cyber_attacks/ThreatSummary.vue